import { createPostAPI } from '@cuemath/rest-api';
import { BASE_URL } from 'constants/api';

const EVAL_HANDOFF_URL = `${BASE_URL}/students/eval-handoff`;

const { usePost: usePostEvalHandoffTrigger } = createPostAPI({
  getURL: (_, intelEnrollmentId) => `${EVAL_HANDOFF_URL}/${intelEnrollmentId}/trigger/`,
});

export { usePostEvalHandoffTrigger };
